import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../node_modules/@fans-fund-me/shared-comm-react-cosmos/dist/shared-comm-react-cosmos.css';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
